<h5>Listado de Prospectos de Venta</h5>
<div class="form-group mb-3">
	<label for="see" class="form-label">Mostrar </label>
	<div class="input-group">
		<label for="onlyPending" (click)="onlyPending = !onlyPending; getPaginationApplications()"
			[ngClass]="onlyPending?'bg-primary':'bg-secondary'" class="input-group-text onlyPending"><i
				[ngClass]="onlyPending?'fa-toggle-on':'fa-toggle-off'" class="fa"></i></label>
		<input type="text" name="onlyPending" id="onlyPending" class="form-control" disabled
			[value]="onlyPending?'Solo pendientes':'Todos'">
	</div>
</div>
<!-- <div class="table-responsive">
	<table class="table">
		<thead>
			<tr class="tr-middle">
				<th colspan="6">Total: {{app?.total}}</th>
			</tr>
			<tr class="tr-middle">
				<th>Fotos</th>
				<th>Empresa</th>
				<th>Encargado</th>
				<th>Locación</th>
				<th>Estado</th>
				<th>Proximo Evento</th>
			</tr>
		</thead>
		<tbody>
			<tr class="tr-middle" *ngFor="let prospect of app?.resumeApplication">
				<td>
					<div class="slider">
						<a *ngFor="let photo of prospect.photoReferences; let i = index">{{i+1}}</a>
						<div class="slides">
							<ng-container *ngFor="let photo of prospect.photoReferences">
								<div
									[style]="'background-image: url(https://s3.amazonaws.com/rrhh-images/companyApplication/referencePhotos/'+ photo +');'">
								</div>
							</ng-container>
						</div>
					</div>
				</td>
				<td>{{prospect.application.newCompany.name}}</td>
				<td>{{prospect.application.userId}}</td>
				<td>{{prospect.application.geolocation}}</td>
				<td>{{prospect.application.pending?'Pendiente':'Terminada'}}</td>
				<td>
					<ng-container *ngIf="prospect.eventGPS">
						<h3>{{prospect.eventGPS?.date | date: 'dd/MM/YYYY'}}
							<i class="fa fa-eye clickeable" [tooltip]="'Ver detalles del evento'"></i>
						</h3>
						<h4>{{prospect.eventGPS?.date | date: 'HH:mm'}}</h4>
						<h5>{{prospect.eventGPS?.date | timeLeft }}</h5>
						<span class="clickeable text-info">Ver todos ({{prospect.totalEvents}}) los eventos</span>
					</ng-container>
					<ng-container *ngIf="!prospect.eventGPS">
						<h5 class="text-muted"><i class="fa fa-circle-info"></i>No se cuenta con un evento proximo</h5>
					</ng-container>
				</td>
			</tr>
		</tbody>
	</table>
</div> -->
<div class="grid">
	<div class="card" [ngClass]="seeing == prospect.application.applicationId?'span-3':''"
		*ngFor="let prospect of app?.resumeApplication">
		<div class="row">
			<div class="col">
				<div class="slider">
					<!-- <a *ngFor="let photo of prospect.photoReferences; let i = index">{{i+1}}</a> -->
					<div class="slides">
						<ng-container *ngFor="let photo of prospect.photoReferences">
							<div class="company"
								[style]="'background-image: url(https://s3.amazonaws.com/rrhh-images/companyApplication/referencePhotos/'+ photo +');'">
							</div>
						</ng-container>
						<div class="title">
							<span class="company-name">{{prospect.application.newCompany.name}}</span>
						</div>
					</div>
				</div>
			</div>
			<div class="col">
				<b>Próximo evento</b>
				<ng-container *ngIf="prospect.eventGPS">
					{{prospect.eventGPS?.date | date: 'dd/MM/YYYY HH:mm'}}
					<p style="font-size: 0.7em;">{{prospect.eventGPS?.date | timeLeft }}</p>
				</ng-container>
				<ng-container *ngIf="!prospect.eventGPS">
					<p style="font-size: 0.9em;" class="text-muted"><i class="fa fa-circle-info"></i>No se cuenta con un
						evento proximo</p>
				</ng-container>
				<p><i tooltip="Creador" class="fa fa-user text-info"></i>{{prospect.application.userId.email}}</p>
				<p *ngIf="prospect.application.coordinates"
					(click)="seeing = seeing == prospect.application.applicationId? null: prospect.application.applicationId">
					<i [class.show-location]="seeing == prospect.application.applicationId" [class.clickeable]="seeing != prospect.application.applicationId" [tooltip]="seeing == prospect.application.applicationId?'Ocultar locación':'Mostrar locación'" class="fa-solid fa-map-location-dot text-info"></i></p>
			</div>
		</div>
		<ng-container *ngIf="prospect.application.coordinates && seeing == prospect.application.applicationId">
			<app-map [coordinates]="[prospect.application.coordinates]"></app-map>
		</ng-container>
	</div>
</div>
<app-simple-pagination [elements]="paginationApplications" [sizes]="sizes"
	(changed)="getPaginationApplications()"></app-simple-pagination>